export default {
  title: 'Meri Bachat',
  language: ['Language', 'English', 'Hindi'],
  dropdown: [
    'Home',
    'About Us',
    'Support Us',
    'Terms and Conditions',
    'Privacy Policy'
  ],
  location: 'Lucknow',
  login: 'Login',
  logout: 'Logout',
  search: 'Search',
  categories: [
    {
      field: 'accessories',
      accessories: 'Accessories',
      subCategories: {
        bags: 'Bags',
        footwear: 'Footwear',
        jewellery: 'Jewellery',
        misc: 'Miscellaneous',
        sports: 'Sports',
        watch: 'Watch'
      },
      index: 0
    },
    {
      field: 'apparel',
      apparel: 'Apparels',
      subCategories: {
        'for-all': 'For All',
        kids: 'Kids',
        men: 'Men',
        women: 'Women'
      },
      index: 1
    },
    {
      field: 'grocery',
      grocery: 'Grocery',
      index: 2
    },
    {
      field: 'e-comm',
      'e-comm': 'E-Commerce',

      index: 3
    },
    {
      field: 'beauty',
      beauty: 'Beauty',

      index: 4
    },
    {
      field: 'food',
      food: 'Food',
      index: 5
    },
    {
      field: 'medicine',
      medicine: 'Medicine',
      index: 6
    },
    {
      field: 'travel',
      travel: 'Travel',
      index: 7,
      subCategories: {
        cab: 'Cabs',
        stay: 'Stay',
        'travel-planner': 'Travel Planner'
      }
    },
    {
      field: 'electronics',
      electronics: 'Electronics',
      index: 8
    },
    {
      field: 'others',
      others: 'Others',
      subCategories: {
        entertainment: 'Entertainment',
        'eye-care': 'Eye Care',
        gifting: 'Gifting',
        'home-decor': 'Home Decor',
        'kids-stationary-books': 'Kids Books and Stationary',
        'service-provider': 'Service Provider',
        wellness: 'Wellness'

      },
      index: 9
    }
  ],

  // groupCategory: [
  //   {
  //     title: 'Portals',
  //     category: {
  //       ecommerce: 'E-Commerce',
  //       grocery: 'Grocery',
  //       'beauty-wellness': 'Beauty & Wellness'
  //     },
  //     index: 6
  //   },
  //   {
  //     title: 'Others',
  //     category: {
  //       'traver-stay': 'Travel/Stay',
  //       'home-decor': 'Home Decor',
  //       jewellery: 'Jewellery',
  //       medicine: 'Medicine'
  //     },
  //     index: 7
  //   }
  // ],
  locationMenu: {
    title: 'Pick a City',
    subTitle: 'To find awesome offers around you',
    searchText: 'Enter your city name',
    searchButton: 'Use My Current Location',
    closeButton: 'Close',
    recommendation: [
      'Top Cities',
      'New Delhi',
      'Gurgaon',
      'Jaipur',
      'Bangalore',
      'Mumbai',
      'Kolkata',
      'Hyderabad',
      'Chennai',
      'Chandigarh',
      'Pune',
      'Ahmedabad',
      'Goa'
    ]
  }
}
